import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AutenticacaoService } from '../services/autenticacao.service';
import { globals } from '../globals';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AutenticacaoService,
    private routerService: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if (this.validaUrl(err)) {
        switch (err.status) {
        // Erro desconhecido
        case 0: break;
          // Bad Request e Internal Server Error
        case 500: break;
        case 400: break;

        case 504: break;

          // Não autorizado
        case 401:
        case 403: {
          // Logout
          this.authenticationService.logoutLocal();
          // Reload
          this.routerService.navigate(['/login']);
          break;
        }
        case 404:{
          this.routerService.navigate(['/']);
          break;
        }
        default:
          break;
        }
      }

      return throwError(err);
    }));
  }

  validaUrl(error: HttpErrorResponse): boolean {
    return error.url.startsWith(globals.apiUrl);
  }
}
